export function localeIgnoreCaseEquals(a: string | undefined | null, b: string | undefined | null) {
  return (a || '').toLocaleLowerCase() === (b || '').toLocaleLowerCase();
}

// checks if substr is a substring of str
export function ignoreCaseIncludes(str: string, substr: string) {
  return str.toLowerCase().includes(substr.toLowerCase());
}
